module.exports = __webpack_public_path__ + "static/media/button-secondary.101f7b67.svg";